import React from "react"; 
import { Container } from "react-bootstrap"; 

const Home=(props)=>{

    return (
        <Container className="mt-4">
            <h1>Home Component</h1>
        </Container>
    )
}

export default Home